<template>
  <client-only>
    <section>
      <div v-if="!showPromoHeaderBanners && activeBanners && activeBanners?.length" class="promo-header__placeholder"></div>
      <div v-if="showPromoHeaderBanners && activeBanners && activeBanners?.length" class="promo-header__banner">
        <transition name="fade" mode="out-in">
          <!-- eslint-disable vue/no-v-html -->
          <div
            :key="currentIndex"
            class="promo-banner__message"
            :class="{
              'promo-banner--disable-pointer': activeBanners[currentIndex]?.originalHref === null
            }"
            :style="{
              backgroundColor: activeBanners[currentIndex].backgroundColor || defaultBackgroundColor,
              color: activeBanners[currentIndex].fontColor || defaultFontColor
            }"
            @click.prevent="handleClick(activeBanners[currentIndex])"
            v-html="$options.filters.sanitize(activeBanners[currentIndex].banner)"
          />
        </transition>
      </div>
    </section>
  </client-only>
</template>

<script>
import xss from 'xss'
import { getActiveBanners } from '~/lib/util/promoHeaderBanners'
import { createPathOrURLWithQueryParam } from '~/lib/util/page'

export default {
  name: 'PromoHeaderBanner',
  filters: {
    sanitize(value) {
      if (!value) {
        return ''
      }
      let sup = value.replace(/<img[^>]*>/gi, '') // remove img tags
      sup = sup.replace(/<script[^>]*>.*?<\/script>/gi, '') // remove script tags
      sup = sup.replace(/<style[^>]*>.*?<\/style>/gi, '') // remove style tags
      sup = sup.replace(/<!--.*?-->/gs, '') // remove comments

      return xss(sup)
    }
  },
  props: {
    banners: {
      type: Array,
      required: false,
      default: () => []
    },
    defaultBanners: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      currentIndex: 0,
      interval: null,
      defaultFontColor: '#000000', // Default font color
      defaultBackgroundColor: '#ffff00', // Default background color
      showPromoHeaderBanners: false
    }
  },
  computed: {
    activeBanners() {
      const scopedActiveBanners = getActiveBanners(this.banners)
      if (scopedActiveBanners.length) {
        scopedActiveBanners && this.$store.commit('utility/SCOPED_promoheaderbanners', scopedActiveBanners, { root: true })
        console.warn('Scoped active banners:', scopedActiveBanners)
        return scopedActiveBanners
      }

      const defaultActiveBanners = getActiveBanners(this.defaultBanners)
      if (defaultActiveBanners.length) {
        defaultActiveBanners && this.$store.commit('utility/DEAFULT_promoheaderbanners', defaultActiveBanners, { root: true })
        console.warn('Default active banners:', defaultActiveBanners)
        return defaultActiveBanners
      }
      console.log('No active banners found')
      return []
    }
  },
  mounted() {
    if (this.activeBanners.length > 1) {
      this.interval = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.activeBanners.length
      }, 10000) // 10 seconds
    }
    this.showPromoHeaderBanners = true
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    handleClick(banner) {
      console.log('Banner clicked:', banner)
      console.log('Banner originalHref:', banner.originalHref)
      if (banner.originalHref) {
        window.location.href = createPathOrURLWithQueryParam({ pathOrURL: banner.originalHref, query: this.$route.query })

        // this.$router.push({
        //   path: banner.originalHref,
        //   query: this.$route.query
        // })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.promo-header {
  &__banner {
    background-color: transparent;
    color: #000;
    text-align: center;
    font-weight: 600;
    font-size: 14px;

    width: 100vw;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1.4;
    z-index: 9999;
    position: relative;

    a {
      font-weight: 700;
      color: #005b1f; // Strong greenish link
      text-decoration: underline;
      margin-left: 4px;

      &:hover {
        text-decoration: none;
      }
    }

    strong {
      color: #1b3e00;
      font-weight: 800;
    }
  }

  &__placeholder {
    width: 100vw;
    min-height: 35px;
    background-color: transparent;
  }
}

::v-deep .top-banner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 25px;
  background-color: #ffe63b;
  color: #000;
  text-align: center;
  font-weight: 600;
  font-size: 13px;
  text-decoration: none;
  line-height: 1;
  z-index: 1000;
  position: relative; // or fixed/top: 0 if sticky
}

::v-deep .top-banner * {
  padding: 0 5px;
}

::v-deep .promo-banner__message {
  width: 100%;
  line-height: 25px;
  padding: 5px 16px;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
}

::v-deep .promo-banner__message.promo-banner--disable-pointer {
  pointer-events: none;

  &:hover {
    cursor: default;
  }
}

::v-deep .promo-banner__message p:first-of-type {
  margin: unset !important;
  width: 100%;
  text-align: center;
}

/* FADE transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
